import axios from "axios";
import { GetEnvironmentConfig } from  '../../App.Config';

export const getVersionNumberAsync = async ():Promise<any> => {
    const request = await axios.get(`/api/v1/appinfo`);
    return request;
}